import React from "react";


import { RegistorClass } from "../core/ComponentRegistor";
import { Form, Input, Select, Button } from 'antd';

const { Option } = Select;


class AntDiyForm1 extends React.Component<any> {
    handleNumberChange = e => {
        const number = parseInt(e.target.value || 0, 10);
        if (isNaN(number)) {
            return;
        }
        this.triggerChange({ number });
    };

    handleCurrencyChange = currency => {
        this.triggerChange({ currency });
    };

    triggerChange = changedValue => {
        const { onChange, value } = this.props;
        if (onChange) {
            onChange({
                ...value,
                ...changedValue,
            });
        }
    };

    render() {
        const { size, value } = this.props;
        return (
            <span>
                <Input
                    type="text"
                    size={size}
                    value={value.number}
                    onChange={this.handleNumberChange}
                    style={{ width: '65%', marginRight: '3%' }}
                />
                <Select
                    value={value.currency}
                    size={size}
                    style={{ width: '32%' }}
                    onChange={this.handleCurrencyChange}
                >
                    <Option value="rmb">RMB</Option>
                    <Option value="dollar">Dollar</Option>
                </Select>
            </span>
        );
    }
}

export class AntDiyForm extends React.Component<any> {
    handleSubmit = e => {
        e.preventDefault();
        this.props.form.validateFields((err, values) => {
            if (!err) {
                console.log('Received values of form: ', values);
            }
        });
    };

    checkPrice = (rule, value, callback) => {
        if (value.number > 0) {
            return callback();
        }
        callback('Price must greater than zero!');
    };

    render() {
        const { getFieldDecorator } = this.props.form;
        return (
            <Form layout="inline" onSubmit={this.handleSubmit}>
                <Form.Item label="Price">
                    {getFieldDecorator('price', {
                        initialValue: { number: 0, currency: 'rmb' },
                        rules: [{ validator: this.checkPrice }],
                    })(<AntDiyForm1 />)}
                </Form.Item>
                <Form.Item>
                    <Button type="primary" htmlType="submit">
                        Submit
          </Button>
                </Form.Item>
            </Form>
        );
    }
}


let scheme = {
    "type": "object",
    "properties": {
        "span": {
            "type": "number",
            "label": "占位",
        },
        "label": {
            "type": "string",
            "label": "显示名",
        }
    }
}
// RegistorClass({
//     componentTag: "AntDiyForm",
//     componentObject: AntDiyForm,
//     componentName: "自定义表单",
//     scheme: scheme,
//     defaultProps: {
//         span: 12,
//         lable: "自定义表单",
//         required: false
//     }
// })
// export default AntInput